export default function RedemptionModalError() {
  return (
    <div
      className="modal fade"
      tabIndex="-1"
      aria-hidden="true"
      aria-label="Redemption Error"
      id="redemption-error-modal"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body px-md-4">
            <div className="vstack gap-4">
              <p className="subhead-1 text-primary mb-1">
                Prime Token Redemption
              </p>
              <div>
                <span className="d-block h2 mb-2">Error!</span>
                <p className="fs-lg">
                  Something went wrong trying to redeem your perks. Please try again.
                </p>
              </div>
            </div>
          </div>
          <div className="modal-footer justify-content-between px-md-4">
            <button
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Back
            </button>

            <button
              className="btn btn-primary"
              aria-label="Refresh & Try Again"
              type="button"
              onClick={() => window.location.reload()}
            >
              Refresh & Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
